module.exports = __webpack_public_path__ + "img/9blue.82f4c2ad.png";